import { render, staticRenderFns } from "./platform-type.vue?vue&type=template&id=cffeed66"
import script from "./platform-type.vue?vue&type=script&lang=js"
export * from "./platform-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports